import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import dayjs from 'dayjs';
import { FormikProps } from 'formik';
import {
  contractEndReasonOptions,
  contract_start_reason,
  employment_contract,
  professional_status,
  working_time_unit,
} from 'utils';
import { validateRate } from 'utils/common_function';

type StaffInfoProps = {
  user?: any;
  onUpdateData?: (data: object) => void;
  formik?: FormikProps<any>;
};

const StaffInfo = ({ formik, user }: StaffInfoProps) => {
  return (
    <div>
      <h1 style={{ fontWeight: 500, fontSize: 20, color: '#000000' }}>
        Contract
      </h1>
      <div style={{ width: '49%', marginTop: 32 }} className='show_item_date'>
        <CustomDatePicker
          value={
            formik?.values?.company_start_date
              ? dayjs(formik?.values?.company_start_date)
              : undefined
          }
          title="Start Date at company"
          height={50}
          fontSize={12}
          borderRadius={6}
          onChange={(e) => {
            // onUpdateData?.({ contract_start_date: e?.format('YYYY-MM-DD') });
            // onUpdateData?.({ company_start_date: e?.format('YYYY-MM-DD') });
            // onUpdateData?.({ seniority_date: e?.format('YYYY-MM-DD') });
            formik.setFieldValue('company_start_date', e?.format('YYYY-MM-DD'));
          }}
        />
      </div>
      <div
        style={{
          marginTop: 30,
          fontWeight: 500,
          fontSize: 16,
          color: '#000000',
        }}
      >
        On-going Contract
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '32px',
          marginTop: '32px',
        }}
      >
        <div style={{ width: '50%' }} className='show_item_date'>
          <CustomDatePicker
            value={
              formik?.values?.contract_start_date
                ? dayjs(formik?.values?.contract_start_date)
                : undefined
            }
            height={50}
            fontSize={12}
            borderRadius={6}
            title="Contract Start Date"
            onChange={(e) => {
              formik.setFieldValue(
                'contract_start_date',
                e?.format('YYYY-MM-DD'),
              );
            }}
            disabledDate={(current) => {
              return (
                current &&
                current > dayjs(formik.values.contract_end_date, 'YYYY-MM-DD')
              );
            }}
          />
        </div>
        <div style={{ width: '50%' }}>
          <CustomDropdown
            defaultKey={formik?.values?.contract_start_reason}
            title="Contract Start Reason"
            height="50px"
            required={user?.role !== "admin"}
            fontSize={12}
            defaultBorder="6px"
            options={contract_start_reason}
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('contract_start_reason', v);
              }
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '32px',
          marginTop: '32px',
        }}
      >
        <div style={{ width: '50%' }} className='show_item_date'>
          <CustomDatePicker
            value={
              formik?.values?.contract_end_date
                ? dayjs(formik?.values?.contract_end_date)
                : undefined
            }
            height={50}
            fontSize={12}
            borderRadius={6}
            onChange={(e) => {
              formik.setFieldValue(
                'contract_end_date',
                e?.format('YYYY-MM-DD'),
              );
            }}
            title="Contract End Date"
            disabledDate={(current) => {
              return (
                current &&
                current < dayjs(formik.values.contract_start_date, 'YYYY-MM-DD')
              );
            }}
          />
        </div>
        <div style={{ width: '50%' }}>
          <CustomDropdown
            defaultKey={formik?.values?.contract_end_reason}
            title="Contract End Reason"
            height="50px"
            fontSize={12}
            defaultBorder="6px"
            options={contractEndReasonOptions}
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('contract_end_reason', v);
              }
            }}
          />
        </div>
      </div>
      <div
        style={{
          width: '100%',
          marginTop: '32px',
          display: 'flex',
          gap: '32px',
        }}
      >
        <div style={{ width: '25%' }}>
          <CustomDropdown
            defaultKey={formik?.values?.employment_contract}
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('employment_contract', v);
              }
            }}
            height="50px"
            fontSize={12}
            defaultBorder="6px"
            title="Employment Contract"
            options={employment_contract}
            width="100%"
          />
        </div>
        <div style={{ width: '25%' }}>
          <CustomDropdown
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('professional_status', v);
              }
            }}
            height="50px"
            fontSize={12}
            defaultBorder="6px"
            title="Professional Status"
            options={professional_status}
            width="100%"
            defaultKey={formik?.values?.professional_status}
          />
        </div>
        <CustomInput
          title={'Qualification'}
          // required
          width={'25%'}
          height="50px"
          fontSize={12}
          value={formik?.values?.qualification}
          name="qualification"
          onChange={formik.handleChange}
        />
        <CustomInput
          title={'Coeffiecient'}
          // required
          width={'25%'}
          name="coefficient"
          height="50px"
          fontSize={12}
          value={formik?.values?.coefficient}
          onChange={formik.handleChange}
        />
      </div>
      <div style={{ display: 'flex', marginTop: '32px', gap: 32 }}>
        <div style={{ width: '33%' }}>
          <CustomDropdown
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('working_time_unit', v);
              }
            }}
            height="50px"
            fontSize={12}
            defaultBorder="6px"
            title="Working Time Unit"
            options={working_time_unit}
            width="100%"
            defaultKey={formik?.values?.working_time_unit}
          />
        </div>
        {/* <div style={{ width: '33%' }}>
          <CustomDropdown title="Activity Type" options={mrs} />
        </div> */}
        <div style={{ width: '33%' }}>
          {/* <CustomInput
            value={formik?.values?.activity_rate}
            title={'Activity Rate'}
            name="activity_rate"
            height="50px"
            fontSize={12}
            // required
            width={'100%'}
            onChange={formik.handleChange}
            type="number"
            min={0}
            max={100}
            onPaste={(e) => {
              e.preventDefault();
            }}
            onKeyDown={validateRate}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default StaffInfo;
